export const letterW = {
  nouns: [
    {"water": ["Wasser", "Wässer", "das", "die", "n"]},
    {"weather": ["Wetter", "Wetter", "das", "die", "n"]},
    {"week": ["Woche", "Wochen", "die", "die", "f"]},
    {"word": ["Wort", "Wörter", "das", "die", "n"]},
    {"question": ["Frage", "Fragen", "die", "die", "f"]},
    {"answer": ["Antwort", "Antworten", "die", "die", "f"]},
    {"time": ["Zeit", "Zeiten", "die", "die", "f"]},
    {"newspaper": ["Zeitung", "Zeitungen", "die", "die", "f"]},
    {"number": ["Zahl", "Zahlen", "die", "die", "f"]},
    {"door": ["Tür", "Türen", "die", "die", "f"]},
    {"tea": ["Tee", "Tees", "der", "die", "m"]},
    {"table": ["Tisch", "Tische", "der", "die", "m"]},
    {"window": ["Fenster", "Fenster", "das", "die", "n"]},
    {"apartment": ["Wohnung", "Wohnungen", "die", "die", "f"]},
    {"wall": ["Wand", "Wände", "die", "die", "f"]},
    {"world": ["Welt", "Welten", "die", "die", "f"]},
    {"wine": ["Wein", "Weine", "der", "die", "m"]},
    {"way": ["Weg", "Wege", "der", "die", "m"]},
    {"economy": ["Wirtschaft", "Wirtschaften", "die", "die", "f"]}

  ],
  verbs: [
    {"to wait": ["warten", "warte", "wartest", "wartet", "wartet", "wartet", "warten", "wartet", "warten", "warten"]},
    {"to live": ["wohnen", "wohne", "wohnst", "wohnt", "wohnt", "wohnt", "wohnen", "wohnt", "wohnen", "wohnen"]},
    {"to wash": ["waschen", "wasche", "wäschst", "wäscht", "wäscht", "wäscht", "waschen", "wascht", "waschen", "waschen"]},
    {"to know a person/place": ["kennen", "kenne", "kennst", "kennt", "kennt", "kennt", "kennen", "kennt", "kennen", "kennen"]},
    {"to know a fact": ["wissen", "weiß", "weißt", "weiß", "weiß", "weiß", "wissen", "wisst", "wissen", "wissen"]},
    {"to want": ["wollen", "will", "willst", "will", "will", "will", "wollen", "wollt", "wollen", "wollen"]},
    {"to become": ["werden", "werde", "wirst", "wird", "wird", "wird", "werden", "werdet", "werden", "werden"]},
    {"to hike": ["wandern", "wandere", "wanderst", "wandert", "wandert", "wandert", "wandern", "wandert", "wandern", "wandern"]},
    {"to change": ["wechseln", "wechsle", "wechselst", "wechselt", "wechselt", "wechselt", "wechseln", "wechselt", "wechseln", "wechseln"]},
    {"to cry": ["weinen", "weine", "weinst", "weint", "weint", "weint", "weinen", "weint", "weinen", "weinen"]},
    {"to repeat": ["wiederholen", "wiederhole", "wiederholst", "wiederholt", "wiederholt", "wiederholt", "wiederholen", "wiederholt", "wiederholen", "wiederholen"]},
    {"to wish": ["wünschen", "wünsche", "wünschst", "wünscht", "wünscht", "wünscht", "wünschen", "wünscht", "wünschen", "wünschen"]}

  ],
  examples: {
    nominative: [
      {
        german: '___ Wasser ist kalt.',
        english: 'The water is cold.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Wetter ist gut.',
        english: 'The weather is good.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Woche ist lang.',
        english: 'The week is long.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Wort ist kurz.',
        english: 'The word is short.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Zeit kommt.',
        english: 'The time comes.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Zeitung ist da.',
        english: 'The newspaper is here.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Tür ist offen.',
        english: 'The door is open.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Fenster ist groß.',
        english: 'The window is large.',
        answer: 'Das',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich trinke ___ Wasser.',
        english: 'I drink the water.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Sie liest ___ Zeitung.',
        english: 'She reads the newspaper.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Zeit.',
        english: 'He needs the time.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir öffnen ___ Tür.',
        english: 'We open the door.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du siehst ___ Fenster.',
        english: 'You see the window.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Ich schreibe ___ Wort.',
        english: 'I write the word.',
        answer: 'das',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Kind.',
        english: 'I help the child.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie geht zu ___ Tür.',
        english: 'She goes to the door.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er spricht mit ___ Lehrer.',
        english: 'He speaks with the teacher.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir sitzen an ___ Tisch.',
        english: 'We sit at the table.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du arbeitest für ___ Zeit.',
        english: 'You work for the time.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Ich komme aus ___ Stadt.',
        english: 'I come from the city.',
        answer: 'der',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The water is cold.',
        german: 'Das Wasser ist kalt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She reads the newspaper.',
        german: 'Sie liest die Zeitung.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I help the child.',
        german: 'Ich helfe dem Kind.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The weather is good.',
        german: 'Das Wetter ist gut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We wait.',
        german: 'Wir warten.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'He lives in Berlin.',
        german: 'Er wohnt in Berlin.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'She washes the car.',
        german: 'Sie wäscht das Auto.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'They know the answer.',
        german: 'Sie wissen die Antwort.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I know the truth.',
        german: 'Ich weiß die Wahrheit.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'You want to go.',
        german: 'Du willst gehen.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'The week is long.',
        german: 'Die Woche ist lang.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'He becomes a teacher.',
        german: 'Er wird Lehrer.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'They wash the car.',
        german: 'Sie waschen das Auto.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'We want to help.',
        german: 'Wir wollen helfen.',
        type: 'translation',
        caseType: 'verb'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to wait" for "I"?',
        answer: 'warte',
        verb: 'warten',
        verbEnglish: 'to wait',
        subject: 'ich',
        conjugation: 'warte'
      },
      {
        question: 'How do you conjugate "to live" for "you" (informal)?',
        answer: 'wohnst',
        verb: 'wohnen',
        verbEnglish: 'to live',
        subject: 'du',
        conjugation: 'wohnst'
      },
      {
        question: 'How do you conjugate "to wash" for "he"?',
        answer: 'wäscht',
        verb: 'waschen',
        verbEnglish: 'to wash',
        subject: 'er',
        conjugation: 'wäscht'
      },
      {
        question: 'What is the simple past of "to wait" for "she"?',
        answer: 'wartete',
        verb: 'warten',
        verbEnglish: 'to wait',
        subject: 'sie',
        conjugation: 'wartete'
      },
      {
        question: 'What is the simple past of "to live" for "we"?',
        answer: 'wohnten',
        verb: 'wohnen',
        verbEnglish: 'to live',
        subject: 'wir',
        conjugation: 'wohnten'
      },
      {
        question: 'What is the simple past of "to wash" for "they"?',
        answer: 'wuschen',
        verb: 'waschen',
        verbEnglish: 'to wash',
        subject: 'sie',
        conjugation: 'wuschen'
      },
      {
        question: 'How do you conjugate "to know a person" for "I"?',
        answer: 'kenne',
        verb: 'kennen',
        verbEnglish: 'to know a person/place',
        subject: 'ich',
        conjugation: 'kenne'
      },
      {
        question: 'What is the simple past of "to know a person" for "she"?',
        answer: 'kannte',
        verb: 'kennen',
        verbEnglish: 'to know a person/place',
        subject: 'sie',
        conjugation: 'kannte'
      },
      {
        question: 'What is the simple past of "to live" for "I"?',
        answer: 'wohnte',
        verb: 'wohnen',
        verbEnglish: 'to live',
        subject: 'ich',
        conjugation: 'wohnte'
      },
      {
        question: 'How do you conjugate "to know a fact" for "I"?',
        answer: 'weiß',
        verb: 'wissen',
        verbEnglish: 'to know a fact',
        subject: 'ich',
        conjugation: 'weiß'
      },
      {
        question: 'What is the simple past of "to know a fact" for "I"?',
        answer: 'wusste',
        verb: 'wissen',
        verbEnglish: 'to know a fact',
        subject: 'ich',
        conjugation: 'wusste'
      },
      {
        question: 'How do you conjugate "to want" for "you" (informal)?',
        answer: 'willst',
        verb: 'wollen',
        verbEnglish: 'to want',
        subject: 'du',
        conjugation: 'willst'
      },
      {
        question: 'What is the simple past of "to want" for "they"?',
        answer: 'wollten',
        verb: 'wollen',
        verbEnglish: 'to want',
        subject: 'sie',
        conjugation: 'wollten'
      },
      {
        question: 'How do you conjugate "to become" for "I"?',
        answer: 'werde',
        verb: 'werden',
        verbEnglish: 'to become',
        subject: 'ich',
        conjugation: 'werde'
      },
      {
        question: 'What is the simple past of "to become" for "she"?',
        answer: 'wurde',
        verb: 'werden',
        verbEnglish: 'to become',
        subject: 'sie',
        conjugation: 'wurde'
      }
    ]
  }
}
